// extracted by mini-css-extract-plugin
export default {"fsSelect":"select-module--fs-select--ac7d8"};